import { React } from "react";
import Navbar from "../layout/Navbar";
import './addnew.css';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

const addnew = () => {
    return (
        <div className="Container">
            <Navbar />
            <div>
                <Card className="text-center">
                    <Card.Header>
                        <form>
                            <table class="table">
                                <tr><td ><input class="sire" type="text" class="form-control" id="exampleFormControlInput1" placeholder="News Title"></input></td>
                                    <td><select class="custom-select">
                                        <option selected>Select News Category</option>
                                    </select>
                                    </td>
                                </tr>
                            </table>
                            <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="News Brief Description"></input>
                            <table class="table">
                                <tr><td ><input class="sire" type="text" class="form-control" id="exampleFormControlInput1" placeholder="Choose pdf"></input></td>
                                    <td><input class="sire" type="text" class="form-control" id="exampleFormControlInput1" placeholder="Explain detail in Text"></input></td>
                                </tr>
                                <tr>
                                <input class="sire" type="text" class="form-control" id="exampleFormControlInput1" placeholder="Choose image"></input>
                                </tr>
                            </table>
                        </form>
                    </Card.Header>
                    <Card.Body>
                        <Card.Title>Special title treatment</Card.Title>
                        <Card.Text>
                            With supporting text below as a natural lead-in to additional content.
                        </Card.Text>
                        <Button variant="primary">Submit</Button>
                    </Card.Body>
                    <Card.Footer className="text-muted">2 days ago</Card.Footer>
                </Card>

            </div>
        </div>
    );
};

export default addnew;